export default {
  getShowById: state => id => {
    return state.shows.find(show => show.id === id);
  },
  activeEdit: state => {
    return state.shows.find(show => show.id === state.editingActiveShowId);
  },
  endPoint: state => {
    if (process.env.NODE_ENV === "development") {
      return state.devEndpoint;
    }
    return state.productionEndpoint;
  },
  showEndpoint: (state, getters) => {
    return getters.endPoint + "/shows/";
  },
  userEndpoint: (state, getters) => {
    return getters.endPoint + "/users/";
  }
};
